export class StarLeaderboardDM {
  constructor({
    user_rank = 0,
    department_rank = 0,
    ranked_users = [],
    top_three_ranked_users = [],
    ranked_departments = [],
    current_user_rank = {
      total_points: 0,
      first_name: "",
      last_name: "",
      thumbnail_image_url: "",
    },
  }) {
    this.user_rank = user_rank;
    this.department_rank = department_rank;
    this.ranked_users = ranked_users;
    this.top_three_ranked_users = top_three_ranked_users;
    this.ranked_departments = ranked_departments;
    this.current_user_rank = current_user_rank;
  }

  static fromJson(data) {
    let leaderboard = new StarLeaderboardDM({
      user_rank: data["user_rank"],
      department_rank: data["department_rank"],
      ranked_users: data["ranked_users"],
      top_three_ranked_users: data["top_three_ranked_users"],
      ranked_departments: data["ranked_departments"],
      current_user_rank: data["current_user_rank"],
    });

    return leaderboard;
  }
}
